import {
    CommonState,
    GET_LOCATION,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_FAILURE,
    MOBILE_SIDEBAR,
    CommonActionTypes
} from "../types/commonType";

const initialState: CommonState = {
    mobileSidebar: false,
    locationList: null,
    getLocationError: null,
    getLocationLoading: false,
};


export const commonReducer = (state = initialState, action: CommonActionTypes): CommonState => {


    switch (action.type) {

        case MOBILE_SIDEBAR: {
            return { ...state, mobileSidebar: action.payload }
        }

        case GET_LOCATION: {
            return { ...state, getLocationError: null, getLocationLoading: true };
        }

        case GET_LOCATION_SUCCESS: {
            return { ...state, locationList: action.payload?.data, getLocationError: null, getLocationLoading: false };
        }

        case GET_LOCATION_FAILURE: {
            return { ...state, getLocationError: action.payload, getLocationLoading: false };
        }



        default:
            return state;
    }
};

